<template>
  <div id="Results">
    <div v-if="selectedView === 'list'">
      <section class="results-banner-container brand-text">
        <div class="content-container">
          <div class="row results-banner align-items-center">
            <div class="results-banner-text col-md-7 col-sm-12">
              <h3 class="welcome brand-text">WELCOME</h3>
              <h1 class="results-banner-title brand-highlight-1 mb-0 pb-0">
                Your results
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class=" content-container pb-5">
          <table class="results-list pb-5 mb-5">
            <tbody>
              <tr
                v-for="(report, i) in reports"
                class="result-row w-100"
                :key="'report-' + i"
              >
                <td class="results-date">
                  {{
                    getFormatedDate(report.date_of_assessment, "Do MMMM YYYY")
                  }}
                </td>
                <td class="results-title">{{ report.header_copy }}</td>
                <td class="results-link brand-primary">
                  <a class="" @click="viewResults(report)">View results</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
    <div v-else>
      <section class="report-banner-container pb-5 brand-text">
        <div class="content-container mb-3 pb-5">
          <i
            class="fa-solid fa-circle-arrow-left fa-3x brand-highlight-1 clickable"
            @click="backToReports()"
          ></i>
        </div>
        <div class="content-container">
          <h4 class="report-banner-title p-text-lg pb-5">
            {{ selectedReport.header_copy }}
          </h4>
          <p class="report-banner-body p-text">
            Please find the results of your assessment on
            <b>{{
              getFormatedDate(selectedReport.date_of_assessment, "Do MMMM YYYY")
            }}</b>
          </p>
          <p class="report-banner-body p-text">
            {{ selectedReport.sub_header_copy }}
          </p>
        </div>
      </section>
      <ResultReport :report_items="selectedReport.report_items"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import config from "../config/constants";
import Loader from "../components/Loader.vue";
import ResultReport from "@/components/ResultReport.vue";

export default {
  name: "results",
  components: {
    ResultReport,
    Loader
  },
  data() {
    return {
      reports: [],
      selectedView: "list",
      selectedReport: null
    };
  },
  mounted() {
    this.getResults();
  },
  methods: {
    backToReports() {
      this.selectedView = "list";
      this.selectedReport = null;
    },
    async getResults() {
      const url =
        config.api_env + "/application/api/u/sapphire/events/user-assessments";
      const payload = {
        user_id: this.$store.getters.user_id
      };
      let res = await this.axios.post(url, payload, config.options);
      if (res.data.success) {
        this.reports = res.data.reports;
        this.loading = false;
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    viewResults(report) {
      this.selectedReport = report;
      this.selectedView = "report";
    }
  },
  computed: {
    supportContacts() {
      return this.$store.state.user.support_contacts;
    }
  }
};
</script>
<style lang="less">
#Results {
  background-color: #fafafa !important;

  .welcome {
    font-size: 1.8rem;
    font-weight: 700;
    letter-spacing: 2.2px;
  }

  .content-container {
    padding-right: 16px;
    padding-left: 16px;
  }

  .results-banner-container {
    .results-banner {
      padding: 50px 16px 30px;
    }

    .results-banner-text {
      font-size: 1.6rem;
      z-index: 2;

      .results-banner-title {
        font-size: 6.4rem;
        font-weight: bold;
      }

      p {
        font-size: 1.8rem;
      }
    }

    div {
      z-index: 2;
    }
  }

  .results-list {
    font-size: 1.6rem;
    width: 100%;

    .results-date {
      max-width: 100px;
    }

    .results-title {
      font-weight: bold;
    }

    .results-link {
      font-weight: bold;
      text-decoration: underline;
      text-align: right;
    }

    tbody td {
      padding: 20px;
    }

    tbody tr:nth-child(odd) {
      background-color: #fff;
    }

    tbody tr:nth-child(even) {
      background-color: #f0f0f0;
    }
  }
  .report-banner-container {
    padding: 60px 0;
    .report-banner-title {
      font-size: 2.4rem;
    }
  }
}
</style>
